import { post, get } from '../Request';
import { axiosPost, axiosGet } from '../../../../../request/http';
// 区域列表
export const queryBounds = ({ success }) => {
    post({
        url: "cfgRegionInfo/findPage",
        data: {
            page: 1,
            size: 10,
            unitid: "1"
        },
        success(res) {
            success(res);

        }
    })
};
// 环境监测
export const queryWeather = ({ success }) => {
    post({
        url: "bizEnvAtmosphericHumidity/findPointInfo",
        data: {},
        success(res) {
            success(res);

        }
    })
};
// 首页环境监测点位
export const getEnvPoint = ({ success }) => {
    get({
        url: "resEnvSlice/realtime",
        data: {},
        success(res) {
            success(res);

        }
    })
};
// 地质监测
export const queryGeology = ({ success }) => {
    post({
        url: "staDisplacement/findPointInfo",
        data: {},
        success(res) {
            success(res);

        }
    })
};
// 设备列表
export const queryEquipment = ({ type, success }) => {
    post({
        url: "resDevice/getRealTimeData",
        data: {
            type
        },
        success(res) {

            success(res);
        }
    })
};
// 热力图 客流密度接口 
export const nowDensity = ({ data, success }) => {
    post({
        url: "bizPassengerflowCamera/getPassengerDensity",
        data,
        success(res) {
            success(res);

        }
    })
};

// 实时厕所使用统计
export const nowToilet = ({ success }) => {
    post({
        url: "staRealToilet/getRealTimeData",
        data: {},
        success(res) {
            success(res);

        }
    })
};
// 实时厕所使用统计
export const queryToilet = () => {
    const params = {
        baseUrl: global.$config.api.apiUrl,
        data: { size: 999, page: 1 }
    }
    return axiosPost(`/data-api/data/data-server/resToiletInfo/findToilet`, params)
};
// 客流监测
export const nowPassenger = ({ success }) => {
    post({
        url: "staPassengerAnalyse/getRealTimeData",
        data: {
        },
        success(res) {
            success(res);

        }
    })
};

// 实时设备状态
export const nowDevice = ({ success }) => {
    post({
        url: "staRealDevice/getRealTimeData",
        data: {},
        success(res) {
            success(res);

        }
    })
};

// 实时车位统计
export const nowParking = ({ success }) => {
    post({
        url: "staRealParking/getRealTimeData",
        data: {},
        success(res) {
            success(res);

        }
    })
};

// 流量
export const rateOfFlow = ({ type, success }) => {
    const methods = {
        keliujiance({ success }) {
            nowPassenger({
                success(res) {
                    if (res) {
                        const arr = res.filter(item => {
                            const { code, flowInNum, flowOutNum, poi, name } = item;
                            item.key = "liuliang|keliujiance|" + code;
                            item.secondText = `进${flowInNum || 0}出${flowOutNum || 0}`;
                            item.screenType = "keliujiance";
                            return poi;
                        })
                        success(arr);
                    } else {
                        success([])
                    }
                }
            })
        },
        midujiance({ success }) {
            nowDensity({
                success(res) {
                    if (res) {
                        const arr = res.dataList.filter(item => {
                            const { deviceCode, density, poi } = item;
                            item.key = "liuliang|midujiance|" + deviceCode;
                            item.secondText = `${density || 0}人`;
                            item.screenType = "midujiance";
                            return poi;
                        })
                        success(arr);
                    } else {
                        success([])
                    }
                }
            })
        },
        tingchechang({ success }) {
            nowParking({
                success(res) {
                    if (res) {
                        const arr = res.filter(item => {
                            const { code, useNum, totalNum, poi } = item;
                            item.key = "liuliang|tingchechang|" + code;
                            item.secondText = `${useNum || 0}/${totalNum || 0}`;
                            item.screenType = "tingchechang";
                            return poi;
                        })
                        success(arr);
                    } else {
                        success([])
                    }
                }
            })
        },
        zhinengcesuo({ success }) {
            // nowToilet({
            //     success(res) {
            //         if (res) {
            //             const arr = res.filter(item => {
            //                 const { code, usingNum, totalNum, poi } = item;
            //                 item.key = "liuliang|tingchechang|" + code;
            //                 item.secondText = `${usingNum}/${totalNum}`;
            //                 item.screenType = "zhinengcesuo";
            //                 return poi;
            //             })
            //             success(arr);
            //         } else {
            //             success([])
            //         }
            //     }
            // })
            queryToilet().then((r) => {
                if (r.code == 0) {
                    const arr = r.data.filter(item => {
                        const { entityCode, usedNum, totalNum, poi } = item;
                        item.key = "liuliang|tingchechang|" + entityCode;
                        item.secondText = `${usedNum || 0}/${totalNum || 0}`;
                        item.screenType = "zhinengcesuo";
                        return poi;
                    })
                    success(arr);
                } else {
                    success([]);
                }
            })
        }
    }
    if (type) {
        methods[type]({
            success
        });
    } else {
        let arr = [];
        let count = 0;
        for (const key in methods) {
            if (methods.hasOwnProperty(key)) {
                const element = methods[key];
                element({
                    success(res) {
                        count++
                        arr = arr.concat(res)

                        if (count === 4) {
                            success(arr);
                        }
                    }
                });
            }
        }
    }
}

// // 网格查询所有
// export const queryGrid = ({success}) => {
//     post({
//         baseURL: "https://sso.xjtstc.com/jk",
//         url:"data-api/data/data-server/resGrid/findAll",
//         data: {},
//         success(res) {
//             success(res);
//             console.log(res, "nowGrid");
//         }
//     })
// };
// // 网格网格单个的
// export const queryGridFindOne = ({success,data}) => {
//     post({
//         baseURL: "https://sso.xjtstc.com/jk",
//         url:"data-api/data/data-server/resGrid/findOne",
//         data: data,
//         success(res) {
//             success(res);
//             console.log(res, "nowGrid");
//         }
//     })
// };

// 网格查询所有(新)
export const queryGrid = ({ success }) => {
    post({
        // baseURL: 'http://tstctest.zjht100.com/analysis',
        url: "cfgGridInfo/findAll",
        data: {},
        success(res) {
            success(res);

        }
    })
};
// 网格网格单个的（新）
export const queryGridFindOne = ({ success, data }) => {
    post({
        // baseURL: 'http://tstctest.zjht100.com/analysis',
        url: "cfgGridInfo/findOne",
        data: data,
        success(res) {
            success(res);

        }
    })
};

//按网格类型查询
export const queryGridFindPage = ({ success, data }) => {
    post({
        // baseURL: 'http://tstctest.zjht100.com/analysis',
        url: "cfgGridInfo/findPage",
        data: data,
        success(res) {
            success(res);

        }
    })
};


// 网格类型
export const queryGridType = (data) => {
    const params = {
        baseUrl: global.$config.api.apiUrl,
        data: data
    }
    return axiosPost(`/common-api/common/findAllPageSDictionary`, params)
};

// 通讯录 组织机构
export const queryOrganization = (data) => {
    const params = {
        baseUrl: global.$config.api.apiUrl,
        data: data
    }
    // return axiosPost(`/permissions-api/permissions/perProject/findAllByProjectCode`, params)
    return axiosPost(`/permissions-api/permissions/perOrganization/findBySysCode`, params)
};
// 通讯录 组织机构
export const queryUserPage = (data) => {
    const params = {
        baseUrl: global.$config.api.apiUrl,
        data: data
    }
    // return axiosPost(`/permissions-api/permissions/perProject/findAllByProjectCode`, params)
    return axiosPost(`/permissions-api/permissions/perUser/findPage`, params)
};

// 获取各环境监测点数据
export const getEnvInfoData = (data) => {
    const params = {
        baseUrl: global.$config.api.analysisUrl,
        data: data
    }
    return axiosPost(`/staEnvIndexDay/statValueOverTime`, params)
};
// 获取环境监测点实时数据
export const getEnvRealtimeData = (data) => {
    const params = {
        baseUrl: global.$config.api.analysisUrl,
        data: data
    }
    return axiosGet(`/resEnvSlice/realtime`, params)
};

// 首页》图纸 项目中心》项目资料
export const getDocList = (data) => {
    const params = {
        baseUrl: global.$config.api.apiUrl,
        data: data
    }
    return axiosGet(`pm-api/pm/pmDoc/list`, params)
};
export const getTotal = (data) => {
    const params = {
        baseUrl: global.$config.api.apiUrl,
        data: data
    }
    return axiosGet(`pm-api/pm/pmGeneral/total`, params)
};

